<accordion [isOpen]="true" (onToggle)="onToggleAccordion($event)" [title]="'APPOINTMENTS.DETAILS.BODY.PAYMENT_DATA.TITLE' | translate" icon="dollar">
	<div class="zk-grid zk-gap-2 zk-grid-cols-2">
		<div class="zk-flex zk-flex-col">
			<p freud-typography fontType="h5SemiboldAuto">
				{{ 'APPOINTMENTS.DETAILS.BODY.PAYMENT_DATA.TYPE' | translate }} 
			</p>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ getSessionType() }}
			</p>
		</div>
		<div class="zk-flex zk-flex-col">
			<p freud-typography fontType="h5SemiboldAuto">
				{{ 'APPOINTMENTS.DETAILS.BODY.PAYMENT_DATA.PAYMENT_STATUS.LABEL' | translate }} 
			</p>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ getPaymentStatus() }}
			</p>
		</div>
		<div *ngIf="shouldShowEstimatedValue()" class="zk-flex zk-flex-col">
			<div class="zk-flex zk-flex-row zk-gap-1">
				<p freud-typography fontType="h5SemiboldAuto">
					{{ 'APPOINTMENTS.DETAILS.BODY.PAYMENT_DATA.ESTIMATED_VALUE' | translate }} 
				</p>
				<span
					freud-tooltip
					[tooltipLabel]="'APPOINTMENTS.DETAILS.BODY.PAYMENT_DATA.TOOLTIP' | translate"
					tooltipPosition="top"
				>
					<span class="freud-icon freud-icon-info-circle freud-icon-sm"></span>
				</span>
			</div>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ eventPrice.value }}
			</p>
		</div>
		<div *ngIf="shouldShowValue()" class="zk-flex zk-flex-col">
			<div class="zk-flex zk-flex-row zk-gap-1">
				<p freud-typography fontType="h5SemiboldAuto">
					{{ 'APPOINTMENTS.DETAILS.BODY.PAYMENT_DATA.VALUE' | translate }} 
				</p>
			</div>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ eventPrice.value }}
			</p>
		</div>
		<div *ngIf="shouldShowExtraInfo()" class="zk-flex zk-flex-col">
			<p freud-typography fontType="h5SemiboldAuto">
				{{ 'APPOINTMENTS.DETAILS.BODY.PAYMENT_DATA.DETAILS' | translate }} 
			</p>
			<div class="zk-flex zk-flex-col">
				<div *ngFor="let info of eventPrice.extraInfo" class="zk-flex zk-flex-row">
					<p class="text" freud-typography fontType="h5RegularAuto">
						{{ info }}
					</p>
				</div>
			</div>
		</div>
		<div *ngIf="shouldShowReceiptButton()" (click)="$event.stopPropagation()" (keyup)="$event.key === 'Enter' ? $event.stopPropagation() : null" class="zk-flex zk-flex-col">
			<app-receipt-button
				[event]="event"
				class="cursor-pointer"
				[shouldDisableReceiptButton]="shouldDisableReceiptButton"
				(onRequestGenerateReceipt)="onRequestGenerateReceipt()"
			>
			</app-receipt-button>
		</div>
	</div>
</accordion>		
		